import { render, staticRenderFns } from "./ConstantIngredientInfo.vue?vue&type=template&id=54162c28&scoped=true&"
import script from "./ConstantIngredientInfo.vue?vue&type=script&lang=js&"
export * from "./ConstantIngredientInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConstantIngredientInfo.vue?vue&type=style&index=0&id=54162c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54162c28",
  null
  
)

export default component.exports